Ext.define('SA.AcsTable.RequestedAttributeIds', {
    constructor() {
        this.idSet = new Set();
    },

    addIds(ids) {
        ids.forEach(id => this.idSet.add(id));
    },

    getIds() {
        return [...this.idSet.values()];
    }
});